export default __webpack_public_path__ + "static/media/wallpaper_01.0545ea40.jpg";